/** Catálogo de aparências de treinador extraídas do Myst (outfits.xml). */
export const TRAINER_LOOKS = Object.freeze([
  { id: 'trainer', labelKey: 'looks.trainer', gender: 'f', slug: 'look-trainer-f' },
  { id: 'trainer', labelKey: 'looks.trainer', gender: 'm', slug: 'look-trainer-m' },
  { id: 'elite', labelKey: 'looks.elite', gender: 'f', slug: 'look-elite-f' },
  { id: 'elite', labelKey: 'looks.elite', gender: 'm', slug: 'look-elite-m' },
  { id: 'adventurer', labelKey: 'looks.adventurer', gender: 'f', slug: 'look-adventurer-f' },
  { id: 'adventurer', labelKey: 'looks.adventurer', gender: 'm', slug: 'look-adventurer-m' },
  { id: 'atletic', labelKey: 'looks.atletic', gender: 'f', slug: 'look-atletic-f' },
  { id: 'atletic', labelKey: 'looks.atletic', gender: 'm', slug: 'look-atletic-m' },
  { id: 'punk', labelKey: 'looks.punk', gender: 'f', slug: 'look-punk-f' },
  { id: 'punk', labelKey: 'looks.punk', gender: 'm', slug: 'look-punk-m' },
  { id: 'mercenary', labelKey: 'looks.mercenary', gender: 'f', slug: 'look-mercenary-f' },
  { id: 'mercenary', labelKey: 'looks.mercenary', gender: 'm', slug: 'look-mercenary-m' },
  { id: 'catcher', labelKey: 'looks.catcher', gender: 'f', slug: 'look-catcher-f' },
  { id: 'catcher', labelKey: 'looks.catcher', gender: 'm', slug: 'look-catcher-m' },
  { id: 'rapper', labelKey: 'looks.rapper', gender: 'f', slug: 'look-rapper-f' },
  { id: 'rapper', labelKey: 'looks.rapper', gender: 'm', slug: 'look-rapper-m' },
  { id: 'jamaican', labelKey: 'looks.jamaican', gender: 'f', slug: 'look-jamaican-f' },
  { id: 'jamaican', labelKey: 'looks.jamaican', gender: 'm', slug: 'look-jamaican-m' },
  { id: 'oriental', labelKey: 'looks.oriental', gender: 'f', slug: 'look-oriental-f' },
  { id: 'oriental', labelKey: 'looks.oriental', gender: 'm', slug: 'look-oriental-m' },
  { id: 'rocket', labelKey: 'looks.rocket', gender: 'f', slug: 'look-rocket-f' },
  { id: 'rocket', labelKey: 'looks.rocket', gender: 'm', slug: 'look-rocket-m' },
  { id: 'business', labelKey: 'looks.business', gender: 'f', slug: 'look-business-f' },
  { id: 'business', labelKey: 'looks.business', gender: 'm', slug: 'look-business-m' },
  { id: 'fisher', labelKey: 'looks.fisher', gender: 'f', slug: 'look-fisher-f' },
  { id: 'fisher', labelKey: 'looks.fisher', gender: 'm', slug: 'look-fisher-m' },
  { id: 'hiker', labelKey: 'looks.hiker', gender: 'f', slug: 'look-hiker-f' },
  { id: 'hiker', labelKey: 'looks.hiker', gender: 'm', slug: 'look-hiker-m' },
  { id: 'police', labelKey: 'looks.police', gender: 'f', slug: 'look-police-f' },
  { id: 'police', labelKey: 'looks.police', gender: 'm', slug: 'look-police-m' },
  { id: 'veteran', labelKey: 'looks.veteran', gender: 'f', slug: 'look-veteran-f' },
  { id: 'veteran', labelKey: 'looks.veteran', gender: 'm', slug: 'look-veteran-m' },
  { id: 'psychic', labelKey: 'looks.psychic', gender: 'f', slug: 'look-psychic-f' },
  { id: 'psychic', labelKey: 'looks.psychic', gender: 'm', slug: 'look-psychic-m' },
]);

export const DEFAULT_TRAINER_GENDER = 'f';
export const DEFAULT_TRAINER_SPRITE = 'look-trainer-f';

export function looksForGender(gender) {
  const g = gender === 'm' ? 'm' : 'f';
  return TRAINER_LOOKS.filter((look) => look.gender === g);
}

export function findLookBySlug(slug) {
  return TRAINER_LOOKS.find((look) => look.slug === slug) || null;
}

export function defaultSpriteForGender(gender) {
  return looksForGender(gender)[0]?.slug || DEFAULT_TRAINER_SPRITE;
}

export function isValidTrainerSprite(slug) {
  return TRAINER_LOOKS.some((look) => look.slug === slug);
}
